import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarDays, Users, BedDouble } from "lucide-react";
import { todayISO, addDaysISO } from "@/lib/site";

export default function BookingBar({ roomId }) {
  const navigate = useNavigate();
  const [checkIn, setCheckIn] = useState(addDaysISO(todayISO(), 2));
  const [checkOut, setCheckOut] = useState(addDaysISO(todayISO(), 3));
  const [guests, setGuests] = useState(2);
  const [rooms, setRooms] = useState(1);

  const submit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams({
      check_in: checkIn,
      check_out: checkOut,
      adults: guests,
      rooms,
    });
    if (roomId) params.set("room", roomId);
    navigate(`/book?${params.toString()}`);
  };

  const field = "flex flex-col gap-1.5";
  const label = "text-[10px] font-semibold uppercase tracking-[0.25em] text-sand/60";
  const input =
    "w-full border border-white/15 bg-white/5 px-3 py-3 text-sm text-sand outline-none transition-colors duration-300 focus:border-gold [color-scheme:dark]";

  return (
    <form
      data-testid="hero-booking-bar"
      onSubmit={submit}
      className="grid grid-cols-2 gap-4 border border-white/20 bg-navy/70 p-5 backdrop-blur-xl sm:grid-cols-3 lg:grid-cols-5 lg:gap-0 lg:divide-x lg:divide-white/10 lg:p-0"
    >
      <div className={`${field} lg:px-6 lg:py-5`}>
        <label className={label} htmlFor="bb-checkin"><CalendarDays size={12} className="mr-1 inline" />Check-In</label>
        <input id="bb-checkin" data-testid="booking-checkin-input" type="date" min={addDaysISO(todayISO(), 2)} value={checkIn}
          onChange={(e) => { setCheckIn(e.target.value); if (e.target.value >= checkOut) setCheckOut(addDaysISO(e.target.value, 1)); }}
          className={input} required />
      </div>
      <div className={`${field} lg:px-6 lg:py-5`}>
        <label className={label} htmlFor="bb-checkout"><CalendarDays size={12} className="mr-1 inline" />Check-Out</label>
        <input id="bb-checkout" data-testid="booking-checkout-input" type="date" min={addDaysISO(checkIn, 1)} value={checkOut}
          onChange={(e) => setCheckOut(e.target.value)} className={input} required />
      </div>
      <div className={`${field} lg:px-6 lg:py-5`}>
        <label className={label} htmlFor="bb-guests"><Users size={12} className="mr-1 inline" />Guests</label>
        <select id="bb-guests" data-testid="booking-guests-select" value={guests} onChange={(e) => setGuests(e.target.value)} className={input}>
          {Array.from({ length: 50 }, (_, i) => i + 1).map((n) => <option key={n} value={n} className="text-navy">{n} Guest{n > 1 ? "s" : ""}</option>)}
        </select>
      </div>
      <div className={`${field} lg:px-6 lg:py-5`}>
        <label className={label} htmlFor="bb-rooms"><BedDouble size={12} className="mr-1 inline" />Rooms</label>
        <select id="bb-rooms" data-testid="booking-rooms-select" value={rooms} onChange={(e) => setRooms(e.target.value)} className={input}>
          {[1, 2, 3, 4].map((n) => <option key={n} value={n} className="text-navy">{n} Room{n > 1 ? "s" : ""}</option>)}
        </select>
      </div>
      <div className="col-span-2 flex sm:col-span-1 lg:col-span-1">
        <button type="submit" data-testid="booking-bar-submit"
          className="w-full bg-gold px-6 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:bg-gold-dark lg:h-full">
          Book Now
        </button>
      </div>
    </form>
  );
}
